import React from 'react';

import './index.pc.scss';

import PcBasicTemplate from 'components/templates/PcBasicTemplate';
import TypeRadio from 'components/atoms/Input/TypeRadio';
import NormalCheckBoxInput from 'components/atoms/Input/NormalCheckBoxInput';
import TextAreaBox from 'components/atoms/Input/TextAreaBox';
import PcMarketPrice from 'components/molecules/PcMarketPrice';
import PcErrorArea from 'components/molecules/PcErrorArea';

const PresentPC = ({ 
  onClickMainButton,
  valid,
  experienceObject,
  qualificationObject,
  qualificationTextObject,
  isApiError,     
  hourSalaryLoading,
  errorDispMap,
  lpMode,
}) => (
  <div className="Skill PC">
    <PcBasicTemplate
      path={window.location.pathname}
      onClickMainButton={onClickMainButton}
      valid={valid}
      isApiError={isApiError}
      lpMode={lpMode}
    >
      <div className="skill-wrapper">
        <div>
          {/* <div className="findicon-area">
            <FindIcon rank='5' />
            <div className="text">= 見つかりやすい</div>
            <FindIcon rank='0' />
            <div className="text">= 見つかりにくい</div>
          </div> */}
          <div className="title">
            {experienceObject.title}
          </div>
          <div className="check-experience">
            {experienceObject.dataList.map((label)=>{
              return(
                <TypeRadio
                  key={label.label}
                  value={label.value}
                  onChange={experienceObject.onChange}
                  checked={experienceObject.data === label.value}
                  label={label.label}
                />
              );
            })}
          </div>
          <div className="mT30">
            <div className="title">
              {qualificationObject.title}
            </div>
            <div className="select-qualification">
              {qualificationObject.dataList.map((label) => {
                return (
                  <NormalCheckBoxInput
                    id={label.value}
                    key={label.label}
                    type="normal"
                    checked={qualificationObject.data.includes(label.value)}
                    label={label.label}
                    onChange={qualificationObject.onChange}
                    value={label.value}
                    color="0"
                  />
                );
              })}
            </div>
          </div>
          <div className="input-qualification-text">
            <TextAreaBox
              name="qualificationText"
              value={qualificationTextObject.data}
              onChange={qualificationTextObject.onChange}
              placeholder="上記に該当しない資格"
              maxLength="100"
              inValid={!!errorDispMap.qualificationText}
            />
            <PcErrorArea message={errorDispMap.qualificationText} />
          </div>
          <div className="market-price mT30">
            {hourSalaryLoading ? (
              <PcMarketPrice
                type="loading"
              />
            ) : (
              <PcMarketPrice
                type="one"
              />
            )}
          </div>
        </div>
      </div>
    </PcBasicTemplate>
  </div>
);

export default PresentPC;